/**
 * Helper — compute an approximate centroid (average of vertices) from a
 * polygon stored in either GeoJSON `{type, coordinates}` form or as a raw
 * array of `[lng, lat]` pairs. Returns `{ lat, lon }` or `null`.
 *
 * Average-of-vertices is good enough for fetching weather (we just need a
 * representative point inside the polygon — Open-Meteo resolution is way
 * coarser than the differences between the true centroid and the average).
 */
export function polygonCentroid(geom) {
  if (!geom) return null;
  let coords = null;
  if (geom?.coordinates) {
    // GeoJSON: Polygon → coordinates[0]; MultiPolygon → coordinates[0][0]
    const first = geom.coordinates[0];
    if (Array.isArray(first) && Array.isArray(first[0]) && Array.isArray(first[0][0])) {
      coords = first[0];
    } else if (Array.isArray(first)) {
      coords = first;
    }
  } else if (Array.isArray(geom) && Array.isArray(geom[0])) {
    // Raw array of points (Leaflet draw shape)
    coords = geom;
  }
  if (!coords || coords.length === 0) return null;
  let lat = 0, lon = 0, n = 0;
  for (const p of coords) {
    if (!Array.isArray(p) || p.length < 2) continue;
    const px = Number(p[0]);
    const py = Number(p[1]);
    if (!Number.isFinite(px) || !Number.isFinite(py)) continue;
    lon += px; lat += py; n += 1;
  }
  return n ? { lat: lat / n, lon: lon / n } : null;
}
